import React from 'react';
import { Button } from './button';
import { Sparkles, Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

interface AIButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'outline' | 'ghost';
  className?: string;
  tooltip?: string;
}

export const AIButton: React.FC<AIButtonProps> = ({
  onClick,
  isLoading = false,
  disabled = false,
  size = 'sm',
  variant = 'outline',
  className,
  tooltip = 'Generate with AI',
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8 p-0',
    md: 'h-10 w-10 p-0',
    lg: 'h-12 w-12 p-0',
  };

  return (
    <Button
      type="button"
      variant={variant}
      size="sm"
      onClick={onClick}
      disabled={disabled || isLoading}
      className={cn(
        sizeClasses[size],
        'flex-shrink-0 transition-all duration-200',
        'hover:bg-purple-50 hover:border-purple-300 hover:text-purple-600',
        'focus:ring-2 focus:ring-purple-500 focus:ring-offset-1',
        isLoading && 'animate-pulse',
        className
      )}
      title={tooltip}
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Sparkles className="h-4 w-4" />
      )}
    </Button>
  );
}; 